import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchBlog } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import { Wrench } from "lucide-react";

const BlogDetail = () => {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    setB(null);
    fetchBlog(slug).then(setB).catch((e) => setErr(e?.response?.status || "error"));
    window.scrollTo({ top: 0 });
  }, [slug]);

  if (err) return (
    <Section><h2 className="font-display text-3xl">Article not found</h2><Link to="/blog" className="mt-4 inline-flex jt-btn jt-btn-outline">All Articles</Link></Section>
  );
  if (!b) return <Section><div className="font-mono text-sm text-[var(--jt-text-muted)]">Loading...</div></Section>;

  return (
    <>
      <PageHero
        eyebrow={b.author || "Workshop Journal"}
        title={b.title}
        intro={b.date ? `Published ${b.date}` : ""}
        breadcrumbs={<>Home / <Link className="hover:text-white" to="/blog">Blog</Link> / <span className="text-white truncate">{b.title}</span></>}
      />
      <Section>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <article className="lg:col-span-8 jt-prose" data-testid="blog-content" dangerouslySetInnerHTML={{ __html: b.description || "" }} />
          <aside className="lg:col-span-4">
            <div className="bg-[var(--jt-ink)] text-white p-6">
              <div className="eyebrow !text-[var(--jt-primary)]">Related Reads</div>
              <ul className="mt-4 space-y-3">
                {(b.related || []).slice(0, 4).map((r) => (
                  <li key={r.slug}>
                    <Link to={`/blog/${r.slug}`} className="block group" data-testid={`related-${r.slug}`}>
                      <div className="flex items-start gap-3">
                        <Wrench className="w-4 h-4 mt-1 text-[var(--jt-primary)] flex-shrink-0" />
                        <div className="font-display font-bold text-sm leading-tight group-hover:text-[var(--jt-primary)] line-clamp-2">{r.title}</div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </Section>
    </>
  );
};

export default BlogDetail;
